import { Component, ElementRef, Renderer2, ViewChild, AfterViewInit, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { DataTableDirective } from "angular-datatables";
import { BaseServiceService } from "src/app/services/base-service.service";
import { Proceso } from "../diagram/diagram.component";
import { ModalNotifyComponent, ModalNotifyTypes } from "../modal-notify/modal-notify.component";
import { HttpClient, HttpErrorResponse, HttpHeaders } from "@angular/common/http";
import { Subject, Subscription, lastValueFrom } from "rxjs";
import { AppData } from "src/app/helpers/app-data";
import { ApiResponse, EstadoCancelacionMasiva } from "src/app/interfaces/generalInterfaces";
import { TareasService } from "src/app/services/tareas.service";

declare var fabric: any;

@Component({
  selector: "app-tareas",
  templateUrl: "./tareas.component.html",
  styleUrls: ["./tareas.component.css"],
})
export class TareasComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ModalNotifyComponent) modalNotifyComponent!: ModalNotifyComponent;

  dialogComponentCreate: any;
  dialogComponentAprobar: any;
  dialogComponentEdit: any;
  formSubmitted: boolean = false;
  botonProcesando = false;
  textoBotonProcesando = "Cargando...";
  idProceso: any;
  idEjecucionTarea;
  idEjecucionProcesoDetalle: any;
  IsCancelProcess: boolean = false;
  dialogComponentCancelarProceso: any;
  cancelProcessForm: FormGroup;
  viewObs: boolean = false;

  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtInstance: DataTables.Api;

  dtOptions: DataTables.Settings = {};
  dtOptButtons: any = [];
  getDataTableTareas: any = ["EjecucionTarea", "GetDataTableEjecucionTarea"];

  response: any[] = [];
  titulo: string = "";
  internalDescription: string = "";

  valorCompartido: any;
  validateDel: boolean = false;
  idTarea: Number;
  idTareaAprobada: Number;
  intervalId: any;
  updateInterval = 100; // Intervalo de actualización del progreso en milisegundos 
  progressPercent = 0;
  progressBar: HTMLElement;
  progressContainer: HTMLElement;

  getsDataTableTareas: string = "EjecucionTarea/GetDataTableEjecucionTarea";

  // Cancelación masiva: la hace el backend en segundo plano; aquí solo se inicia y se sigue el avance.
  totalTareas: number | null = null;
  cancelarTodasForm: FormGroup;
  dialogCancelarTodas: any;
  enviandoCancelarTodas = false;
  cancelacionEnCurso: EstadoCancelacionMasiva | null = null;
  private seguimientoCancelacion?: Subscription;

  dtOptionsReady: boolean = false;
  buscarPorVariables: boolean = false;
  tableVisible: boolean = true;

  columnas = [
    { title: "ID", data: "Id" },
    { title: "Nombre Proceso", data: "NombreProceso" },
    { title: "Tarea", data: "NombreTarea" },
    { title: "Estado", data: "EstadoEjecucion" },
    { title: "Fecha Asignación", data: "FechaAsignacion" },
    { title: "Fecha Expiración", data: "FechaExpira", defaultContent: "Sin vencimiento", render: (d: any) => d ?? "Sin vencimiento" },
    { title: "Desviacion", data: "Desviacion" },
  ];

  constructor(
    private baseService: BaseServiceService,
    private router: Router,
    private renderer: Renderer2,
    private http: HttpClient,
    private elementRef: ElementRef,
    private _formBuilder:FormBuilder,
    private tareasService: TareasService
  ) {}

  async ngOnInit(): Promise<void> {
    this.dtOptButtons.push({'button-id': 'btnVerFormulario', 'button-icon': 'ms-Icon--View', 'conditional-data': [
      { key: 'proceso-id', value: 'IdEjecucionProceso' },
      { key: 'formulario-id', value: 'IdFormulario' }
    ], "button-tooltip": "Ver Formulario" },
    {'button-id': 'btnCancelarTarea', 'button-icon': 'ms-Icon--StatusCircleBlock', 'conditional-data': [
      { key: 'procesodetalle-id', value: 'IdEjecucionProcesoDetalle' }
    ], "button-tooltip": "Cancelar Tarea" });

    this.cancelProcessForm = this._formBuilder.group({
      Observacion: new FormControl('', [Validators.required, Validators.maxLength(1000)])
    });

    this.cancelarTodasForm = this._formBuilder.group({
      Observacion: new FormControl('', [Validators.required, Validators.maxLength(1000)]),
      Confirmado: new FormControl(false, [Validators.requiredTrue])
    });

    this.progressBar = document.getElementById('progressBar');
    this.progressContainer = document.getElementById('progressContainer');

    // Si el usuario salió de la pantalla con una cancelación en curso, se retoma su seguimiento.
    const idJobActivo = this.tareasService.jobActivo();
    if (idJobActivo) {
      this.cancelacionEnCurso = { IdJob: idJobActivo, Estado: 'EnCola', Total: 0, Procesadas: 0, Canceladas: 0, Fallidas: [] };
      this.seguirCancelacion(idJobActivo, true);
    }

    this.startProgressCycle();
  }

  startProgressCycle() {
    setTimeout(() => {
      this.showProgressBar();
    }, AppData.tiempo_refresh_Tareas);
  }

  showProgressBar() {
    this.progressPercent = 0;
    this.progressContainer.style.display = 'block';
    const totalUpdates = 2000 / this.updateInterval; // 2 segundos de progreso

    const updateProgress = () => {
      this.progressPercent += 100 / totalUpdates;
      this.progressBar.style.width = this.progressPercent + '%';

      if (this.progressPercent >= 100) {
        clearInterval(this.intervalId);
        setTimeout(() => {
          this.hideProgressBar();
        }, 1000); // Espera 1 segundo antes de ocultar el loader y recargar la tabla
      }
    };

    this.intervalId = setInterval(updateProgress, this.updateInterval);
  }

  hideProgressBar() {
    this.progressContainer.style.display = 'none';
    this.reloadDataTable();
    this.startProgressCycle();
  }

  async ngAfterViewInit(): Promise<void> {
    this.dtInstance = await this.dtElement.dtInstance;
    this.dtInstance.on('draw', () => {
      // Aquí puedes agregar cualquier lógica que necesites ejecutar después de que se dibuje la tabla
    });

    this.elementRef.nativeElement.addEventListener("click", (event) => {
      if (event.target.id === "btnDescargarDocumento") {
        const id = parseInt(event.target.getAttribute("data-id"));
        this.descargarDocumentoValidacion(id);
      }
    });
  }

  ngOnDestroy(): void {
    if (this.dtInstance) {
      this.dtInstance.off("draw");
    }

    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    // El trabajo sigue en el servidor; solo se deja de consultar su avance.
    this.seguimientoCancelacion?.unsubscribe();
  }

  gridLoaded(event: any) {
    this.dtInstance = event['table'];
    this.totalTareas = this.dtInstance.page.info()?.recordsTotal ?? null;
    this.dtInstance.on('draw.cancelarTodas', () => {
      this.totalTareas = this.dtInstance.page.info()?.recordsTotal ?? null;
    });
  }

  get porcentajeCancelacion(): number {
    const estado = this.cancelacionEnCurso;
    return estado?.Total ? Math.round((estado.Procesadas / estado.Total) * 100) : 0;
  }

  abrirCancelarTodas(): void {
    this.cancelarTodasForm.reset({ Observacion: '', Confirmado: false });
    this.dialogCancelarTodas = new fabric["Dialog"](document.querySelector(".cancelar-todas-dialog"));
    this.dialogCancelarTodas.open();
  }

  cerrarCancelarTodas(): void {
    this.dialogCancelarTodas?.close();
    this.cancelarTodasForm.reset({ Observacion: '', Confirmado: false });
  }

  /** Un solo llamado: el backend encola el trabajo y devuelve su Id para seguir el avance. */
  async confirmarCancelarTodas(): Promise<void> {
    if (this.cancelarTodasForm.invalid || this.enviandoCancelarTodas) {
      return;
    }
    this.enviandoCancelarTodas = true;
    try {
      const cancelacion = await this.tareasService.iniciarCancelacionMasiva(this.cancelarTodasForm.get('Observacion').value.trim());
      this.cancelacionEnCurso = { IdJob: cancelacion.IdJob, Estado: 'EnCola', Total: cancelacion.Total, Procesadas: 0, Canceladas: 0, Fallidas: [] };
      this.seguirCancelacion(cancelacion.IdJob);
    } catch (error) {
      this.dialogCancelarTodas?.close();
      this.baseService.triggerShowModal('No se pudo cancelar', this.escaparHtml(this.mensajeError(error)), ModalNotifyTypes.Danger, false);
    } finally {
      this.enviandoCancelarTodas = false;
    }
  }

  /** retomada: viene de sessionStorage; si el job ya no existe se descarta sin molestar al usuario. */
  private seguirCancelacion(idJob: string, retomada = false): void {
    this.seguimientoCancelacion?.unsubscribe();
    this.seguimientoCancelacion = this.tareasService.seguirCancelacion(idJob).subscribe({
      next: (estado) => {
        const anterior = this.cancelacionEnCurso?.Canceladas ?? 0;
        this.cancelacionEnCurso = estado;
        if (estado.Canceladas !== anterior) {
          this.reloadDataTable();
        }
        if (this.tareasService.esFinal(estado)) {
          this.finalizarCancelacion(estado);
        }
      },
      error: (error) => {
        this.cancelacionEnCurso = null;
        this.tareasService.olvidarJob();
        if (!retomada) {
          this.baseService.triggerShowModal('No se pudo consultar la cancelación', this.escaparHtml(this.mensajeError(error)), ModalNotifyTypes.Danger, false);
        }
      },
    });
  }

  private finalizarCancelacion(estado: EstadoCancelacionMasiva): void {
    this.tareasService.olvidarJob();
    this.cancelacionEnCurso = null;
    this.dialogCancelarTodas?.close();
    this.cancelarTodasForm.reset({ Observacion: '', Confirmado: false });
    this.reloadDataTable();

    const omitidas = estado.Procesadas - estado.Canceladas - estado.Fallidas.length;
    const detalleOmitidas = omitidas > 0 ? ` ${omitidas === 1 ? '1 ya estaba cancelada' : omitidas + ' ya estaban canceladas'}.` : '';
    if (estado.Estado === 'Completada' && estado.Fallidas.length === 0) {
      this.baseService.triggerShowModal(
        'Tareas canceladas',
        (estado.Canceladas === 1 ? 'Se canceló 1 tarea.' : `Se cancelaron ${estado.Canceladas} tareas.`) + detalleOmitidas,
        ModalNotifyTypes.Success,
        false
      );
      return;
    }

    const detalle = estado.Fallidas.map((fallo) => `<li>${this.escaparHtml(fallo)}</li>`).join('');
    const motivo = estado.Estado === 'Fallida' ? ' El proceso en segundo plano se detuvo antes de terminar.' : '';
    this.baseService.triggerShowModal(
      'Algunas tareas no se cancelaron',
      `Se cancelaron ${estado.Canceladas} de ${estado.Total} tareas.${motivo}${detalle ? `<ul>${detalle}</ul>` : ''}`,
      ModalNotifyTypes.Warning,
      false
    );
  }

  private mensajeError(error: unknown): string {
    if (error instanceof HttpErrorResponse) {
      const detalle = error.error?.ValidationErrors?.join(' ') || error.error?.Error;
      return detalle || (error.status === 0 ? 'No hay conexión con el servidor.' : `El servidor respondió con un error (${error.status}).`);
    }
    return error instanceof Error && error.message ? error.message : 'Ocurrió un error inesperado. Intenta de nuevo.';
  }

  private escaparHtml(texto: string): string {
    return texto.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }


  customClick(event: any) {
    try {
      let idEjecucionTarea = event["data-id"];
      let formSubmitted = event["data-formulario-id"];
      let idEjecucionProceso = event["data-proceso-id"];
      this.idEjecucionProcesoDetalle = event["data-procesodetalle-id"];

      switch (event['button-id']) {
        case 'btnVerFormulario':
          this.baseService.exportIDForm(formSubmitted);
          this.baseService.exportIdEjecucionProceso(idEjecucionProceso);
          this.baseService.exportIdEjecucionTarea(idEjecucionTarea);

          this.router.navigate(["home/formulario"]);
          break;
        case 'btnCancelarTarea':
  
            this.IsCancelProcess = true;
            this.viewObs = false;
    
            const dialogSendActionProcess = document.querySelector(".cancel-observation");
            this.dialogComponentCancelarProceso = new fabric["Dialog"](dialogSendActionProcess);
            this.dialogComponentCancelarProceso.open();

            break;
      }
    } catch (error) {
      console.error("Error al retornar evento datatable", error);
    }
  }

  clearCancelForm()
  {
    this.cancelProcessForm.reset();
  }

  async enviarAccionProceso()
  {

    const response = await lastValueFrom(this.http.post<any>(AppData.API_URL+"EjecucionProceso/AccionProceso?IdEjecucionDetalle="+this.idEjecucionProcesoDetalle+"&IsCancel="+this.IsCancelProcess+'&Observacion='+(this.IsCancelProcess ? this.cancelProcessForm.get('Observacion').value : null), null));

    if (!response.Ok) {

      let mensajeError = "<ul>";
      response.ValidationErrors.forEach((error: any) => {
        mensajeError += `<li>${error}</li>`;
      });
      mensajeError += "</ul>";

      this.baseService.triggerShowModal(
        "Error al cancelar proceso",
        mensajeError,
        ModalNotifyTypes.Danger,
        false
      );
      
    } else {

      if(this.IsCancelProcess)
      {
        this.dialogComponentCancelarProceso.close();
      }

      this.baseService.triggerShowModal(
        "Proceso cancelado",
        "Proceso cancelado exitosamente",
        ModalNotifyTypes.Success,
        false
      );

      this.reloadDataTable();
      
    }

    this.cancelProcessForm.reset();

  }

  async descargarDocumentoValidacion(idArchivo: number) {
    try {
      const responseDocumentos = await lastValueFrom(
        this.http.get<any>(
          AppData.API_URL +
            `EjecucionProceso/DocumentosEjecucionProceso?IdEjecucion=${this.idEjecucionTarea}`
        )
      );

      const ejecucionProcesoObj = responseDocumentos.Data.find(
        (item: any) => item.Id === idArchivo
      );

      if (!ejecucionProcesoObj) {
        console.error(`Documento con Id ${idArchivo} no encontrado`);
        return;
      }
      this.descargarDocumentoGeneral(
        idArchivo,
        ejecucionProcesoObj.NombreDocumento
      );
    } catch (error) {
      console.error("Error obteniendo la lista de documentos", error);
    }
  }

  async descargarDocumentoGeneral(idArchivo: number, NombreDocumento: string) {
    try {
      const response = await lastValueFrom(
        this.http.get(
          AppData.API_URL +
            `EjecucionProceso/DescargarDocumento?IdArchivo=${idArchivo}`,
          { responseType: "blob" }
        )
      );
      const url = window.URL.createObjectURL(response);
      const a = document.createElement("a");
      a.href = url;
      a.download = NombreDocumento;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error descargando el documento", error);
    }
  }

  reloadDataTable(): void {
   /*  this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.ajax.reload(null, false);
    }); */
    this.dtInstance.ajax.reload(null,false)

  }

  onBuscarPorVariablesChange(): void {
    const endpoint = this.buscarPorVariables
      ? 'GetDataTableEjecucionTareaByVariables'
      : 'GetDataTableEjecucionTarea';
    this.getDataTableTareas = ['EjecucionTarea', endpoint];
    // Re-initialize the datatable with the new endpoint
    this.tableVisible = false;
    setTimeout(() => { this.tableVisible = true; }, 0);
  }
}
